import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { TaxRateShiftsEffects } from './taxrate-shifts.effects';
import { ITaxRateShiftsFeature } from './taxrate-shifts.feature.state';
import { taxRateShiftsReducer } from './taxrate-shifts.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ITaxRateShiftsFeature>('taxRateShiftsFeature'), taxRateShiftsReducer),
    EffectsModule.forFeature([TaxRateShiftsEffects]),
  ],
})
export class TaxRateShiftsStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: TaxRateShiftsStateModule
  ) {
    if (parentModule) {
      throw new Error('TaxRateShiftsStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
